module.exports = __webpack_public_path__ + "img/icon2.87750367.png";